import type { Locales } from '@captaincause/types'

export function formatNumber(number: number, locale: Locales) {
  return Intl.NumberFormat(locale).format(number)
}
